export const RECEIVE_PLAYLISTS = 'RECEIVE_PLAYLISTS'
export const RECEIVE_PLAYLISTS_ERROR = 'RECEIVE_PLAYLISTS_ERROR'
export const RECEIVE_PLAYLIST = 'RECEIVE_PLAYLIST'
export const CLEAR_PLAYLISTS = 'CLEAR_PLAYLISTS'
export const RECEIVE_PLAYLIST_CATEGORIES = 'RECEIVE_PLAYLIST_CATEGORIES'
export const RECEIVE_PLAYLIST_CHANNELS = 'RECEIVE_PLAYLIST_CHANNELS'
export const DELETE_RELATED_PLAYLIST_CONTENT = 'DELETE_RELATED_PLAYLIST_CONTENT'
export const RECEIVE_RELATED_PLAYLIST_CONTENT = 'RECEIVE_RELATED_PLAYLIST_CONTENT'
